module.exports = __webpack_public_path__ + "static/img/B21-KITE_A.7d73af2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/B21-KITE_A.jpg
// module id = n3RC
// module chunks = 0